var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-radio-group',{attrs:{"row":""},on:{"change":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_c('v-radio',{attrs:{"label":"Özel","value":_vm.sirketTipi.ozel}}),_c('v-radio',{attrs:{"label":"Kamu","value":_vm.sirketTipi.kamu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }